import React from "react";
import { Button, Tooltip } from "antd";
import { Link } from "react-router-dom";

import "./ActionsIcons.scss";

const ActionsIcons = ({ actions = [] }) => {
   return (
      <div className="icon-group">
         {actions
            .filter((action) => !action.condition || action.condition())
            .map((action, index) => (
               <div key={index} className="icon-container">
                  {action.tooltip ? (
                     <Tooltip title={action.tooltip} placement="bottom">
                        {action.link ? (
                           <Link to={action.link} onClick={action.onClick}>
                              {action.icon}
                           </Link>
                        ) : (
                           <Button onClick={action.onClick} disabled={action.disabled}>
                              {action.icon}
                           </Button>
                        )}
                     </Tooltip>
                  ) : action.link ? (
                     <Link to={action.link} onClick={action.onClick}>
                        {action.icon}
                     </Link>
                  ) : (
                     <Button onClick={action.onClick} disabled={action.disabled}>
                        {action.icon}
                     </Button>
                  )}
               </div>
            ))}
      </div>
   );
};

export default ActionsIcons;
